import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { storeFilingThreshold, filingThresholdFor } from '../../../common/filingThreshold';
// import Grid from '@material-ui/core/Grid';
// import IntlMessages from "../../../../util/IntlMessages";
import { Get1099ComplianceReview, UpdateVendor1099, MarkVendorReview, GetReviewVendorHistory, InsertUpdateComplianceReviewNotes, GetComplianceReviewNotes, Update1099ReviewExcludeTotalStatus, VendorStopMonitoring } from "../../../../appRedux/actions/LedgerAction";
import { vendorTypes, SetVendorType, doNotIssueDeopdownValues } from "../../../../appRedux/actions/vendorAction";
// import { tsConstructorType } from "@babel/types";
import { makeLinkForQuickbooks, numberWithCommas, Getsum, MaskTaxIdentifier, ReportType, GetSyncDateFormat, LinkType } from "../../../common/commonServices";
import { UpdateVendorDoNotIssue1099 } from "../../../../appRedux/actions/ReportDetailAction";
import CircularProgress from '../../../../components/CircularProgress';
import { toast } from "react-toastify";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';
import HistoryIcon from '@material-ui/icons/History';
import Tooltip from '@material-ui/core/Tooltip';
import '../NewLedgerPage/style.css';
// import { stat } from "fs";
// import Select from '@material-ui/core/Select';
import Textarea from 'react-expanding-textarea';
import { Note } from "@material-ui/icons";
import { red } from "@material-ui/core/colors";
import VendorsLogHistory from '../../../common/vendorsHistoryModel'
import { dropdownValueMapping, resolveVendor1099 } from '../../../common/1099ReportingDataMapping'
import { withStyles } from '@material-ui/core/styles';
import './ReviewReportPage.css';

const FontTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: 12
  },
}))(Tooltip);

class ReviewReportPage extends Component {

  constructor(props) {

    super(props)
    let eDate = new Date();
    let sDate = new Date(eDate.getFullYear(), 0, 1);

    if (eDate.getMonth() <= 2) {
      sDate = new Date(sDate.getFullYear() - 1, 0, 1);
      eDate = new Date(eDate.getFullYear() - 1, 11, 31);
    }
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= currentYear - 25; year--) {
      if (year >= 2020) {
        years.push(year);
      }
    }
    this.years = years

    this.state = {
      companyId: 0,
      loading: false,
      sDate: sDate,
      eDate: eDate,
      ReportData: [],
      editedData: null,
      vendorTypeData: [],
      doNotIssueDropdownOptions: [],
      selectedListId: "",
      selectedTypeId: 0,
      IsReviewProcessing: false,
      ShowHistory: false,
      editNotes: false,
      Notes: "",
      prevNotes: "",
      editIndex: -1,
      exclude1099Note: "This transaction is not included in the 1099 total.",
      isExcludeFrom1099ReviewTotal: null,
      editDoNotIssueIndex: -1,
      editData: null,
      prevDoNotIssueText: "",
      ShowHistoryModal: false,
      hasrendered: false,
      // Add a flag to track if history has been loaded initially
      hasInitialHistoryLoaded: false,
      showHistoryAfterReview: false,
      expandall: true,
      collapsall: false,
      ExcludeMonitoring: false,
      Vendor1099: false,
      isDataLoadedSuccessfully: false,
      preservedExpandStates: {},
      selectAllStopMonitoring: false,
      selectAll1099Vendor: false,
      checkboxInteracted: false
    }
  }


  componentDidMount() {
    let user = JSON.parse(localStorage.getItem('userData'));
    this.setState({
      companyId: user.companyId,
      loading: true,
      isDataLoadedSuccessfully: false,
    }, () => {
      this.props.GetReviewVendorHistory(user.companyId);
      this.props.vendorTypes();
      this.props.doNotIssueDeopdownValues()
      this.GetReportData();
    });

    //  setTimeout(() => {
    //       if (this.state.HistoryData && this.state.HistoryData.length > 0) {
    //           this.setState({ ShowHistory: true });
    //       }
    //   }, 2000); 

  }



  GetReportData = () => {
    // Loads the year's 1099 filing threshold for the W-9 placeholder rule.
    storeFilingThreshold(this, moment(this.state.eDate).year());
    let body = {
      "companyID": this.state.companyId,
      "fromDate": moment(this.state.sDate).format("MM/DD/YYYY"),
      "toDate": moment(this.state.eDate).format("MM/DD/YYYY"),
      "needUpdatQBORecords": false,
      "reportType": ReportType.Vendor1099ComplianceReview,
      "isExcludeMonitoring": this.state.ExcludeMonitoring,
      "isVendor1099": this.state.Vendor1099
    }
    this.props.Get1099ComplianceReview(body);
  }

  componentWillReceiveProps(nextprops) {
    if (nextprops.ComplianceReviewData !== undefined && nextprops.ComplianceReviewData !== this.props.ComplianceReviewData) {
      if (nextprops.ComplianceReviewData.transactionStatus === 0) {
        if (nextprops.ComplianceReviewData.returnObject != null && nextprops.ComplianceReviewData.returnObject.length > 0) {
          let data = nextprops.ComplianceReviewData.returnObject;
          // Restore saved expansion states, or default to true if not previously set
          data.forEach(element => {
            element.isExpand = this.state.preservedExpandStates[element.listID] !== undefined
              ? this.state.preservedExpandStates[element.listID]
              : true;
          });
          this.setState({ loading: false, ReportData: data, isDataLoadedSuccessfully: true, preservedExpandStates: {} })
          this.props.GetComplianceReviewNotes(this.state.companyId, ReportType.Vendor1099ComplianceReview);
        }
        else {
          this.setState({ loading: false, ReportData: [], isDataLoadedSuccessfully: true, preservedExpandStates: {} });
          this.props.GetComplianceReviewNotes(this.state.companyId, ReportType.Vendor1099ComplianceReview);
        }
      }
      else {
        this.setState({ loading: false, ReportData: [], isDataLoadedSuccessfully: false }, () => { toast.error(`${nextprops.ComplianceReviewData.resultMsg}`); });
        this.props.GetComplianceReviewNotes(this.state.companyId, ReportType.Vendor1099ComplianceReview);
      }
    }

    if (nextprops.HistoryData !== undefined && nextprops.HistoryData != null && nextprops.HistoryData.returnObject != this.props.HistoryData) {
      if (nextprops.HistoryData.transactionStatus === 0) {
        if (!this.state.hasInitialHistoryLoaded || this.state.showHistoryAfterReview) {
          this.setState({
            ShowHistory: true,
            HistoryData: nextprops.HistoryData.returnObject,
            hasInitialHistoryLoaded: true,
            showHistoryAfterReview: false
          });
        } else {
          this.setState({
            HistoryData: nextprops.HistoryData.returnObject
          });
        }
      }
    }

    if (nextprops.GetComplianceReviewNotesData !== undefined && nextprops.GetComplianceReviewNotesData != this.props.GetComplianceReviewNotesData) {

      if (nextprops.GetComplianceReviewNotesData.transactionStatus === 0) {
        if (nextprops.GetComplianceReviewNotesData.returnObject != null) {
          this.setState({ loading: false, Notes: nextprops.GetComplianceReviewNotesData.returnObject.notes });
        } else {
          this.setState({ loading: false, Notes: "" });
        }
      }
    }

    if (nextprops.ComplianceReviewNotesUpdate !== undefined && nextprops.ComplianceReviewNotesUpdate !== this.props.ComplianceReviewNotesUpdate) {

      if (nextprops.ComplianceReviewNotesUpdate.transactionStatus === 0) {
        this.setState({ editNotes: false, Notes: this.state.prevNotes }, () => { toast.success(`${nextprops.ComplianceReviewNotesUpdate.resultMsg}`); });
        this.props.GetComplianceReviewNotes(this.state.companyId, ReportType.Vendor1099ComplianceReview);
      }
      else {
        this.setState({ loading: false }, () => { toast.error(`${nextprops.ComplianceReviewNotesUpdate.resultMsg}`); });
      }
    }

    if (nextprops.CommonUpdate !== undefined && nextprops.CommonUpdate !== this.props.CommonUpdate) {
      if (nextprops.CommonUpdate.transactionStatus === 0) {
        let data = this.state.ReportData;
        if (this.state.IsReviewProcessing == false && this.state.editedData != null) {
          let obj = this.state.editedData;
          data.map((item, index) => {
            if (item.listID === obj.listID) {
              item.vendor1099 = obj.vendor1099
            }
          })

          this.setState({ editedData: null, IsReviewProcessing: false, reportData: data, selectAllStopMonitoring: false, checkboxInteracted: false }, () => {
            toast.success("Request Process Successfully");
            this.GetReportData();
          });
        }
        else if (this.state.IsReviewProcessing == true) {
          this.setState({ IsReviewProcessing: false, selectAllStopMonitoring: false, checkboxInteracted: false }, () => {
            toast.success("Reviewed Successfully");
            this.props.GetReviewVendorHistory(this.state.companyId);
            this.GetReportData();
          });
        }
        else {
          // Handle stop monitoring or other updates
          this.setState({ loading: false, selectAllStopMonitoring: false, checkboxInteracted: false }, () => {
            toast.success("Updated Successfully");
            this.GetReportData();
          });
        }
      }
      else {
        this.setState({ loading: false }, () => { toast.error(`${nextprops.CommonUpdate.resultMsg}`); });
      }
    }
    if (nextprops.vendorTypeData !== undefined && nextprops.vendorTypeData !== this.props.vendorTypeData) {
      this.setState({ vendorTypeData: nextprops.vendorTypeData });
    }

    if (nextprops.doNotIssueDropdownOptions !== undefined && nextprops.doNotIssueDropdownOptions !== this.props.doNotIssueDropdownOptions) {
      this.setState({ doNotIssueDropdownOptions: nextprops.doNotIssueDropdownOptions.returnObject });
    }
    if (nextprops.wagesUpdate !== undefined && nextprops.wagesUpdate !== this.props.wagesUpdate) {
      this.setState({ loading: false }, () => {

        if (nextprops.wagesUpdate.transactionStatus === 0) {
          const data = [...this.state.ReportData];
          let selectedid = this.state.selectedListId;
          data.forEach(element => {
            if (element.listID === selectedid) {
              element.vendorTypeId = parseInt(this.state.selectedTypeId);
              // The API may have changed the 1099 setting with the type; show what it saved.
              const vendor1099 = resolveVendor1099(element.vendorTypeId, element.doNotIssue1099);
              if (vendor1099 !== null) {
                element.vendor1099 = vendor1099;
              }
            }
          });
          this.setState({ ReportData: data, selectedListId: "", selectedTypeId: 0 }, () => {
            toast.success("Updated successfully.");
            // this.GetReportData();
          });

        }
        else {
          this.setState({ loading: false }, () => { toast.error("failed to update.") });
        }
      });
    }

    if (nextprops.LEDGER_UPDATE != undefined && nextprops.LEDGER_UPDATE !== this.props.LEDGER_UPDATE) {
      if (nextprops.LEDGER_UPDATE.transactionStatus === 0) {

        this.setState({
          loading: false, editIndex: -1, isExcludeFrom1099ReviewTotal: null
        }, () => {
          toast.success("Record updated successfully");
          // this.GetReportData();
        });

      }
      else {
        this.setState({
          loading: false, editIndex: -1, isExcludeFrom1099ReviewTotal: null
        }, () => {
          toast.error(`${nextprops.LEDGER_UPDATE.resultMsg}`);
        });
      }
    }

    if (nextprops.UpdateDescription !== this.props.UpdateDescription) {
      if (nextprops.UpdateDescription.transactionStatus === 0) {
        // The API may have changed the 1099 setting with the reporting issue; show what it saved.
        const editedVendor = this.state.editData;
        const vendor1099 = editedVendor ? resolveVendor1099(editedVendor.vendorTypeId, editedVendor.doNotIssue1099) : null;
        if (vendor1099 !== null) {
          editedVendor.vendor1099 = vendor1099;
        }
        this.setState({
          // loading: true
          loading: false,
          editDoNotIssueIndex: -1, editData: null, prevDoNotIssueText: ""
        }, () => {
          toast.success(`${nextprops.UpdateDescription.resultMsg}`);
          // this.GetReportData();
        });
      }
      else {
        this.setState({
          loading: false, editDoNotIssueIndex: -1, editData: null, prevDoNotIssueText: ""
        }, () => {
          toast.error(`${nextprops.UpdateDescription.resultMsg}`);
        });
      }
    }
  }
  CloseHistory = () => {
    this.setState({ ShowHistoryModal: false });
  }
  getHistory = (item) => {
    this.setState({ vendorID: item.vendorID, ShowHistoryModal: true })


  }
  onMarkReviewd = () => {
    this.setState({
      IsReviewProcessing: true,
      //  loading: true
      IsReviewProcessing: true,
      showHistoryAfterReview: true,
      loading: false
    }, () => {
      this.props.MarkVendorReview(this.state.companyId);
    });
  }

  YearChange = (e) => {
    this.setState({ eDate: new Date(e.target.value, 11, 31), sDate: new Date(e.target.value, 0, 1), ReportData: [], isDataLoadedSuccessfully: false, loading: true }, () => {

      this.GetReportData();
    });
  }

  onLinkClick = (rowData) => {
    let origin = makeLinkForQuickbooks();
    window.open(origin + rowData.transactionLink);
  }

  onCheckboxClick = (e, item) => {
    const expandStates = {};
    this.state.ReportData.forEach(vendor => {
      expandStates[vendor.listID] = vendor.isExpand;
    });
    this.setState({ preservedExpandStates: expandStates });

    let body = {
      "companyID": this.state.companyId,
      "vendor1099": e.target.checked,
      "listID": item.listID
    }

    this.setState({
      editedData: body,
      loading: false
    }, () => {
      this.props.UpdateVendor1099(body);
    })
  }

  ChangeType = (e, listId) => {
    var obj =
    {
      "listId": listId,
      "vendorTypeId": e.target.value === "" ? null : e.target.value,
      "companyId": this.state.companyId
    }

    this.setState({
      // loading: false
      loading: false, selectedListId: listId, selectedTypeId: e.target.value
    }, () => {
      this.props.SetVendorType(obj)
    });

  }

  HandleClose = () => {
    this.setState({ ShowHistory: false });
  }

  onClickCloseButtonDate = (e) => {
    this.setState({ editNotes: false, Notes: this.state.prevNotes });
  }

  handalTextArea = (e) => {
    this.setState({ Notes: e.target.value });
  }

  editNotesData = () => {
    this.setState({ editNotes: true, prevNotes: this.state.Notes });
  }

  UpdateNotes = () => {
    var obj =
    {
      "companyID": this.state.companyId,
      "reportType": ReportType.Vendor1099ComplianceReview,
      "notes": this.state.Notes
    }

    this.setState({
      // loading: true
      loading: false
    }, () => {
      this.props.InsertUpdateComplianceReviewNotes(obj)
    });

  }

  onRowSave = (index, rowData, vendorData) => {
    if (this.state.isExcludeFrom1099ReviewTotal) {
      if (vendorData.vendor1099 != true) {
        toast.error("Not able to exclude transactions because the vendor is not selected as a 1099 vendor.");
        return false;
      }
    }

    let body =
    {
      "id": rowData.id,
      "isExcludeFrom1099Total": this.state.isExcludeFrom1099ReviewTotal,
      "companyID": this.state.companyId,
      "reportType": ReportType.Vendor1099ComplianceReview
    }

    this.setState({
      // loading: true
      loading: false
    }, () => {
      this.props.Update1099ReviewExcludeTotalStatus(body);
    });
  }

  onRowCancel = (rowIndex, rowData) => {
    //rowData.memoOrDescription = null;
    this.setState({ isExcludeFrom1099ReviewTotal: null, editIndex: -1 });
  }

  onRowEdit = (j, rowData) => {
    this.setState({ isExcludeFrom1099ReviewTotal: rowData.isExcludeFrom1099Total, editIndex: j });
  };

  onChange1099ExcludeCheckbox = (e) => {
    this.setState({ isExcludeFrom1099ReviewTotal: e.target.checked });
  }

  editDoNot1099Data = (index, rowData) => {
    let data = [...this.state.ReportData];
    if (this.state.editData != null && this.state.editDoNotIssueIndex != -1) {
      data[this.state.editDoNotIssueIndex].doNotIssue1099 = this.state.prevDoNotIssueText;
    }
    this.setState({ ReportData: data, editDoNotIssueIndex: index, editData: rowData, prevDoNotIssueText: rowData.doNotIssue1099 });
  }

  handleFormChange = (e, index) => {
    var data = this.state.editData;
    data.doNotIssue1099 = e.target.value
    this.setState({ editData: data });
  }

  onClickCloseDoNot1099 = (e, index) => {
    let data = [...this.state.ReportData];
    data[index].doNotIssue1099 = this.state.prevDoNotIssueText;
    this.setState({ ReportData: data, editData: null, editDoNotIssueIndex: -1 });
  }

  saveDoNotIssue1099 = (item) => {
    let editedData = this.state.editData;
    const totalpayments = Getsum(item.reportData.filter(a => a.transactionType !== "Bill"), "amount")
    let flag = false;
    if (Getsum(item.reportData.filter(a => a.transactionType !== "Bill"), "amount") >= filingThresholdFor(this.state.filingThresholds, moment(this.state.eDate).year()) && this.state.editData.vendor1099 && (this.state.editData.doNotIssue1099 === "6"
      || this.state.editData.doNotIssue1099 === "7" || this.state.editData.doNotIssue1099 === "8")) {
      flag = true
    }
    // if (editedData.doNotIssue1099 == null || editedData.doNotIssue1099.trim().replace(/\s/g, '') === "") {
    //     toast.error("Please select Do Not Issue 1099 value.");
    //     return false;
    // }

    let body = {
      "companyID": this.state.companyId,
      "id": editedData.vendorID,
      "doNotIssue1099": editedData.doNotIssue1099,
      "reportType": ReportType.Vendor1099PendingClientApproval,
      // "listID": item.listID,
      "isUpdateVendorEINAndAddress": flag
    }

    this.setState({
      // loading: true
      loading: false
    }, () => {
      this.props.UpdateVendorDoNotIssue1099(body);
    })
  }

  onExpandAllChange = (isChecked) => {
    let data = [...this.state.ReportData];
    data.forEach(element => { element.isExpand = isChecked });
    this.setState({ expandall: true, collapsall: false, ReportData: data });
  }

  onCollapseAllChange = (isChecked) => {
    let data = [...this.state.ReportData];
    data.forEach(element => { element.isExpand = isChecked });
    this.setState({ collapsall: true, expandall: false, ReportData: data });
  }

  onStopMonitoringChange = (isChecked) => {
    this.setState({ loading: true, ExcludeMonitoring: isChecked, ReportData: [], isDataLoadedSuccessfully: false, selectAllStopMonitoring: false, checkboxInteracted: false }, () => {
      this.GetReportData();
    });
  }

  onVendor1099Change = (isChecked) => {
    this.setState({ loading: true, Vendor1099: isChecked, ReportData: [], isDataLoadedSuccessfully: false, selectAllStopMonitoring: false, checkboxInteracted: false }, () => {
      this.GetReportData();
    });
  }

  onStopMonitoringVendorChange = (e, item) => {
    const expandStates = {};
    this.state.ReportData.forEach(vendor => {
      expandStates[vendor.listID] = vendor.isExpand;
    });
    this.setState({ preservedExpandStates: expandStates });

    let body = {
      "companyID": this.state.companyId,
      "vendors": [
        {
          "listId": item.listID,
          "excludeMonitoring": e.target.checked
        }
      ]
    }

    this.setState({
      loading: false,
    }, () => {
      this.props.VendorStopMonitoring(body);
    });
  }

  onSelectAllStopMonitoring = (isChecked) => {
    const data = [...this.state.ReportData];
    data.forEach(item => {
      if (item.reportData && item.reportData.length > 0 && item.reportData[0].vendor != null && item.reportData[0].vendorID !== 0) {
        item.reportData[0].excludeMonitoring = isChecked;
      }
    });
    this.setState({ ReportData: data, selectAllStopMonitoring: isChecked, checkboxInteracted: true });
  }

  onBulkSave = () => {
    const expandStates = {};
    this.state.ReportData.forEach(vendor => {
      expandStates[vendor.listID] = vendor.isExpand;
    });
    this.setState({ preservedExpandStates: expandStates });

    const data = this.state.ReportData;
    const stopMonitoringVendors = [];

    data.forEach(item => {
      if (item.reportData && item.reportData.length > 0 && item.reportData[0].vendor != null && item.reportData[0].vendorID !== 0) {
        // Collect all valid vendors with their new state
        stopMonitoringVendors.push({
          "listId": item.listID,
          "excludeMonitoring": this.state.selectAllStopMonitoring
        });
      }
    });

    // Send Stop Monitoring API call if vendors to update
    if (stopMonitoringVendors.length > 0) {
      const stopMonitoringBody = {
        "companyID": this.state.companyId,
        "vendors": stopMonitoringVendors
      };
      this.props.VendorStopMonitoring(stopMonitoringBody);
    }
  }

  render() {
    return (
      <div className="dashboardPage compliance-review-1099-page">
        <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
          <h2 className="title mb-3 mb-sm-0 compliance-review-1099-title">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | 1099 Compliance Review</h2>
        </div>
        {/* {this.state.ShowHistory && this.state.HistoryData != null && this.state.HistoryData.length > 0 &&
          <React.Fragment>
            <Dialog
              className="comment-Top-align"
              maxWidth="sm"
              fullWidth={true}
              open={true}>
              <React.Fragment>
                <div className="Comments modal-header"><span className="log-history-title float-left">Reviewed History </span>
                  <Button className="jr-btn close-btn float-right" onClick={this.HandleClose}><ClearIcon /></Button>
                </div>
                <DialogContent>
                  {this.state.HistoryData.length == 0 ?
                    <div className="history-box">
                      <p className="history-item-text">No History Found</p>
                    </div>
                    :
                    <React.Fragment>
                      {this.state.HistoryData.map((item, i) => (
                        <div className="history-box">
                          {/* <p className="history-item-text">
                           
                          </p>
                           */}
        {/* <p className="history-date-text"> <strong style={{ color: "black" }}>  Last Reviewed  </strong> By <strong> {item.userName}</strong> <strong> on </strong>{item.stCreatedDate}</p>
                        </div>
                      ))}
                    </React.Fragment>
                  }
                </DialogContent>
              </React.Fragment>
            </Dialog>
          </React.Fragment>

        } */}
        <div className="padding-box app-wrapper compliance-review">
          <div className="row">
            <div className="col-md-4">
              <div className="left-box">

                {!this.state.editNotes ?
                  <div className="col-md-12">
                    <h5>Notes: {this.state.Notes}
                      <span className="" onClick={(e) => this.editNotesData()}>
                        <i className="zmdi zmdi-edit zmdi-hc-lg ml-4 pointer"></i>
                      </span>
                    </h5>
                  </div>
                  :
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-1" style={{ marginTop: "5px" }}>
                        <h5>Notes:</h5>
                      </div>
                      <div className="col-md-7" style={{ marginLeft: "-60px" }}>
                        <Textarea className="placheholder-color"
                          value={this.state.Notes} name="Notes"
                          style={{ 'lineHeight': '20px', width: '100%', border: 'none', resize: 'none', padding: '6px', paddingLeft: '10px', borderRadius: '3px', border: '1px solid #ccc', overflow: 'hidden' }}
                          resize={"false"} placeholder=""
                          onChange={(e) => this.handalTextArea(e)} />
                      </div>
                      <div className="col-md-2" style={{ marginLeft: "-10px", marginTop: "4px" }}>
                        {/* <Button variant="contained" className="graycolor jr-btn bg-teal text-white refresh-btn" onClick={() => this.UpdateNotes()} >Save</Button> */}
                        <Button className="jr-btn close-btn" onClick={(e) => this.UpdateNotes(e)}><CheckIcon /></Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button className="jr-btn close-btn" onClick={(e) => this.onClickCloseButtonDate(e)}><ClearIcon /></Button>

                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>

            <div className="col-md-5">
              <table className="compliance-review-1099-filters">
                <tbody>
                  <tr>
                    <td>
                      <div className="checkbox pointer" >
                        <div className="chiller_cb">
                          <input id="ExcludeMonitoring" type="checkbox" checked={this.state.ExcludeMonitoring} onChange={() => this.onStopMonitoringChange(!this.state.ExcludeMonitoring)} />
                          <label htmlFor="ExcludeMonitoring">
                            <p className="checkbox-title">Display Vendors Checked as Stop Monitoring</p>
                          </label>
                          <span></span>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className="checkbox pointer" >
                        <div className="chiller_cb">
                          <input id="Vendor1099" type="checkbox" checked={this.state.Vendor1099} onChange={() => this.onVendor1099Change(!this.state.Vendor1099)} />
                          <label htmlFor="Vendor1099">
                            <p className="checkbox-title">Display 1099 Vendors</p>
                          </label>
                          <span></span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="col-md-3">
              <div className="float-right last-reviewed-container">
                <p className="Font15PX">
                  <span>
                    <strong>Last Reviewed History:</strong>
                  </span>
                  &nbsp;
                  {(() => {
                    const hasHistory = this.state.HistoryData && this.state.HistoryData.length > 0;

                    const displayText = hasHistory
                      ? (() => {
                        const latest = [...this.state.HistoryData].sort((a, b) => b.id - a.id)[0];
                        const formattedDate = GetSyncDateFormat(latest.stCreatedDate);
                        const reviewer = latest.userName || "Unknown";
                        return `${formattedDate} by ${reviewer}`;
                      })()
                      : "No review found";

                    return (
                      <a
                        className="review-history-link"
                        onClick={() => {
                          if (hasHistory) {
                            this.setState({ ShowReview: true });
                          }
                        }}
                        style={{
                          cursor: hasHistory ? "pointer" : "default",
                          textDecoration: hasHistory ? "underline" : "none",
                          color: "#0066cc"
                        }}
                        title={hasHistory ? "Click to view full history" : ""}
                      >
                        {displayText}
                      </a>
                    );
                  })()}
                </p>

                {this.state.ShowReview && (
                  <Dialog
                    className="comment-Top-align"
                    maxWidth="sm"
                    fullWidth={true}
                    open={true}
                  >
                    <React.Fragment>
                      <div className="Comments modal-header">
                        <span className="log-history-title float-left">Reviewed History</span>
                        <Button
                          className="jr-btn close-btn float-right"
                          onClick={() => this.setState({ ShowReview: false })}
                        >
                          <ClearIcon />
                        </Button>
                      </div>

                      <DialogContent>
                        {(!this.state.HistoryData || this.state.HistoryData.length === 0) ? (
                          <div className="history-box">
                            <p className="history-item-text">No History Found</p>
                          </div>
                        ) : (
                          this.state.HistoryData.map((item, i) => (
                            <div className="history-box" key={i}>
                              <p className="history-date-text">
                                <strong className="text-black">Last Reviewed</strong> by{" "}
                                <strong>{item.userName}</strong> <strong>on</strong> {item.stCreatedDate}
                              </p>
                            </div>
                          ))
                        )}
                      </DialogContent>
                    </React.Fragment>
                  </Dialog>
                )}
              </div>
            </div>
          </div>

          <div className="row compliance-review-1099-controls">
            <div className="col-md-12">
              <div className="float-right compliance-review-1099-actions">
                {this.state.loading === false ?
                  <> <span>Select Year:</span>
                    <select className="select-box arrow-box compliance-review-1099-year" name="year" onChange={(e) => this.YearChange(e)} value={this.state.eDate.getFullYear()}>
                      {/* <option value=""></option> */}
                      {this.years.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </select></>
                  : ""}
                {this.state.loading === false ?
                  <Button variant="contained" className="graycolor jr-btn bg-teal text-white refresh-btn" onClick={() => this.onMarkReviewd()} >Mark as Reviewed</Button>
                  : ""}
              </div>
            </div>
          </div>

          {/* One horizontal scroll for the whole data area, so the Select-All strip
              stays lined up with the vendor columns beneath it. */}
          <div className="compliance-review-1099-scroll">
          {/*Used to show the Select all checkbox for Stop Monotiring and Vendor 1099*/}
          {!this.state.loading && this.state.ReportData && this.state.ReportData.length > 0 &&
            <div className="row" style={{ marginBottom: "0px", marginTop: "0px" }}>
              <div className="col-md-12">
                <div className="vendor-header-grid" style={{ cursor: "default" }}>
                  <div style={{ gridColumn: "1 / 5" }}></div>
                  <div className="vendor-col checkbox-col" style={{ gridColumn: "5" }}>
                    <label style={{ margin: 0 }}><strong>Select All Stop Monitoring</strong></label>
                    <input type="checkbox" checked={this.state.selectAllStopMonitoring} onChange={(e) => this.onSelectAllStopMonitoring(e.target.checked)} />
                  </div>
                  <div style={{ gridColumn: "6", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    {this.state.loading === false && this.state.checkboxInteracted ?
                      <Button variant="contained" className="graycolor jr-btn bg-teal text-white refresh-btn" onClick={() => this.onBulkSave()}> Save </Button>
                      : null}
                  </div>
                </div>
              </div>
            </div>
          }

          {this.state.loading ?
            <div className="compliance-review-1099-loader">
              <CircularProgress />
            </div>
            :
            <React.Fragment>
              {/* {JSON.stringify(this.state)} */}
              {this.state.ShowHistoryModal ? <VendorsLogHistory Module="Vendors History"
                CompanyId={this.state.companyId}
                VendorId={this.state.vendorID}
                CloseHistory={this.CloseHistory} /> : ''}

              {this.state.ReportData != null && this.state.ReportData.length > 0 ? this.state.ReportData.map((item, i) => (
                <div className="vendor-block" key={item.listID ? item.listID : `item-${i}`}>
                  <div className="vendor-header-grid" style={{ cursor: "default" }}>
                    <div className="vendor-col vendor-name" style={{
                      gridColumn: ((item.vendorID === item.employeeId && item.employeeId !== 0) ||
                        (item.vendorID === item.customerId && item.customerId !== 0)) ? "1 / -1" : "auto"
                    }}>
                      <h5 style={{ margin: "0px", cursor: "pointer" }} onClick={() => {
                        let data = [...this.state.ReportData];
                        data[i].isExpand = !data[i].isExpand;
                        this.setState({ ReportData: data });
                      }}>
                        {item.isExpand ? <i className="zmdi zmdi-minus-circle-outline" /> : <i className="zmdi zmdi-plus-circle-o" />}
                        <span><strong>{item.vendor +
                          (item.vendorID === item.employeeId && item.employeeId !== 0
                            ? " - (Employee)"
                            : item.vendorID === item.customerId && item.customerId !== 0
                              ? " - (Customer)"
                              : "")}</strong></span>
                      </h5>
                    </div>

                    {!((item.vendorID === item.employeeId && item.employeeId !== 0) ||
                      (item.vendorID === item.customerId && item.customerId !== 0)) && (
                        <React.Fragment>
                          <div className="vendor-col taxid-col">
                            <strong>Tax ID Number: {MaskTaxIdentifier(item.taxIdentifier)}</strong>
                          </div>

                          <div className="vendor-col issue-col">
                            <strong>W-9/1099 Reporting Issues:</strong>
                            {this.state.editDoNotIssueIndex == i ?
                              <React.Fragment>
                                <select className="select-box arrow-box" name="doNotIssue1099" onChange={(e) => this.handleFormChange(e, i)} value={this.state.editData.doNotIssue1099} style={{ marginRight: "5px" }}>
                                  <option value=""></option>
                                  {this.state.doNotIssueDropdownOptions.map(type => (
                                    <option key={type.id} value={type.id}>
                                      {type.description}
                                    </option>
                                  ))}
                                </select>
                                <Button className="jr-btn close-btn" onClick={(e) => this.saveDoNotIssue1099(item)}><CheckIcon /></Button>
                                <Button className="jr-btn close-btn" onClick={(e) => this.onClickCloseDoNot1099(e, i)}><ClearIcon /></Button>
                              </React.Fragment>
                              :
                              <React.Fragment>
                                {item.doNotIssue1099 ?
                                  <span className="issue-text" style={{ color: "red" }} title={dropdownValueMapping[`${item.doNotIssue1099}`]}>
                                    {dropdownValueMapping[`${item.doNotIssue1099}`]}
                                  </span>
                                  : null
                                }
                                <i className="zmdi zmdi-edit zmdi-hc-lg edit-icon" onClick={(e) => this.editDoNot1099Data(i, item)} style={{ cursor: "pointer" }} />
                              </React.Fragment>
                            }
                            {/* History sits outside the edit/read branches so the icon stays
                                visible while a row is being edited. */}
                            <Tooltip title="W-9/1099 Reporting Issues history">
                              <Button className="jr-btn close-btn issue-history-btn" onClick={(e) => { this.getHistory(item) }}><HistoryIcon /></Button>
                            </Tooltip>
                          </div>

                          <div className="vendor-col type-col">
                            <strong>Type:</strong>
                            <select className="select-box" name={item.listID} value={item.vendorTypeId || ""} onChange={(e) => this.ChangeType(e, item.listID)}>
                              <option value="">Select</option>
                              {this.state.vendorTypeData.map(type => (
                                <option key={type.vendorTypeId} value={type.vendorTypeId}>
                                  {type.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          {item.reportData && item.reportData.length > 0 && item.reportData[0].vendor != null && item.reportData[0].vendorID !== 0 ?
                            <React.Fragment>
                              <div className="vendor-col checkbox-col" style={{ gridColumn: "5" }}>
                                <label><strong>Stop Monitoring This Vendor</strong></label>
                                {item.reportData[0].excludeMonitoring ?
                                  <input type="checkbox" checked={true} onChange={(e) => this.onStopMonitoringVendorChange(e, item)} />
                                  :
                                  <input type="checkbox" checked={false} onChange={(e) => this.onStopMonitoringVendorChange(e, item)} />
                                }
                              </div>

                              <div className="vendor-col checkbox-col" style={{ gridColumn: "6" }}>
                                <label><strong>1099 Vendor</strong></label>
                                {item.vendor1099 ?
                                  <input type="checkbox" name={item.listID} checked={true} onChange={(e) => this.onCheckboxClick(e, item)} />
                                  :
                                  <input type="checkbox" name={item.listID} checked={false} onChange={(e) => this.onCheckboxClick(e, item)} />
                                }
                              </div>
                            </React.Fragment>
                            : null
                          }
                        </React.Fragment>
                      )}
                  </div>

                  <div className="compliance-review-1099-table-wrap">
                    {item.isExpand &&
                      <table className="table compliance-review-1099-table">
                        <thead>
                          <tr className="header-bg-color">
                            <th>
                              Date
                            </th>
                            <th>
                              Type
                            </th>
                            <th>
                              Number
                            </th>
                            <th>
                              Memo/Description
                            </th>
                            <th className="compliance-review-1099-col-account">
                              Account
                            </th>
                            <th className="text-center"> Amount   </th>
                            <th className="text-center">
                              Exclude from 1099 Total
                            </th>
                            <th className="text-center"><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.reportData != null & item.reportData.length > 0 ?
                            <React.Fragment key={i}>

                              <tr>
                                <td colSpan="8" align="left" > <b>Bills</b> </td>
                              </tr>

                              {item.reportData != null && item.reportData.filter(a => a.transactionType === "Bill").map((data, index) => (
                                <React.Fragment key={index}>
                                  {
                                    data.isExcludeFrom1099Total ?
                                      <tr onClick={(e) => this.onRowEdit(data.id, data)}>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note}> {data.date}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note}>{data.transactionType}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note}>{data.num}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note}>{data.memoOrDescription}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note}> {data.accountValue}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note} className="text-center pr-2">${numberWithCommas(data.amount)}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note} className="text-center"> <i class="zmdi zmdi-close zmdi-hc-2x" style={{ color: "red" }}></i></td>
                                        <td style={{ width: "12%", backgroundColor: "lightgrey" }} title={this.state.exclude1099Note} className="text-center"><img alt="link" src="/vendors/grrenLink.png" onClick={(e) => this.onLinkClick(data)}></img></td>
                                      </tr>
                                      :
                                      <tr onClick={(e) => this.onRowEdit(data.id, data)}>
                                        <td> {data.date}</td>
                                        <td>{data.transactionType}</td>
                                        <td >{data.num}</td>
                                        <td>{data.memoOrDescription}</td>
                                        <td> {data.accountValue}</td>
                                        <td className="text-center pr-2">${numberWithCommas(data.amount)}</td>
                                        <td></td>
                                        <td style={{ width: "12%" }} className="text-center"><img alt="link" src="/vendors/grrenLink.png" onClick={(e) => this.onLinkClick(data)}></img></td>
                                      </tr>
                                  }
                                  {this.state.editIndex === data.id && //item.vendor1099 &&
                                    <React.Fragment>
                                      <tr className="editRowColor review-1099-edit-row">
                                        <td colSpan={4}></td>
                                        <td colSpan={4}>
                                          <div className="review-1099-edit-controls">
                                            <div className="chiller_cb ">
                                              <input id="isExcludeFrom1099Total" name="isExcludeFrom1099Total" type="checkbox" checked={this.state.isExcludeFrom1099ReviewTotal} onChange={(e) => this.onChange1099ExcludeCheckbox(e)} />
                                              <label htmlFor="isExcludeFrom1099Total">
                                                <p className="checkbox-title" style={{ fontSize: "14px" }}>Exclude From 1099 Total</p>
                                              </label>
                                              <span></span>
                                            </div>
                                            <Button variant="contained" className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.onRowSave(data.id, data, item)}>SAVE</Button>
                                            <Button variant="contained" className="jr-btn jr-btn-sm bg-danger text-white" onClick={() => this.onRowCancel(data.id, data)}>CANCEL</Button>
                                          </div>
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  }
                                </React.Fragment>
                              ))}
                              {item.reportData.filter(a => a.transactionType === "Bill" && a.isExcludeFrom1099Total == true).length > 0 &&
                                <React.Fragment>
                                  <tr>
                                    <td colSpan="4"></td>
                                    <td><h2 className="total-payments-text">Adjusted Total 1099 Bills</h2></td>
                                    <td className="text-center pr-2 compliance-review-1099-total-amount"><h1 className="total-text"> ${Getsum(item.reportData.filter(a => a.transactionType === "Bill" && a.isExcludeFrom1099Total != true), "amount")} </h1></td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                </React.Fragment>
                              }
                              <tr>
                                <td colSpan="4"></td>
                                <td><h2 className="total-payments-text">Total Bills</h2></td>
                                <td className="text-center pr-2 compliance-review-1099-total-amount"><h1 className="total-text"> ${Getsum(item.reportData.filter(a => a.transactionType === "Bill"), "amount")} </h1></td>
                                <td></td>
                                <td></td>
                              </tr>

                              <tr>
                                <td colSpan="8" align="left" > <b>Payments </b> </td>
                              </tr>
                              {item.reportData != null && item.reportData.filter(a => a.transactionType !== "Bill").map((data, index) => (
                                <React.Fragment key={index}>
                                  {
                                    data.isExcludeFrom1099Total ?
                                      <tr onClick={(e) => this.onRowEdit(data.id, data)}>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note}> {data.date}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note}>{data.transactionType}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note}>{data.num}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note}>{data.memoOrDescription}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note}> {data.accountValue}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note} className="text-center pr-2">${numberWithCommas(data.amount)}</td>
                                        <td style={{ backgroundColor: "lightgrey" }} title={this.state.exclude1099Note} className="text-center"> <i class="zmdi zmdi-close zmdi-hc-2x" style={{ color: "red" }}></i></td>
                                        <td style={{ width: "12%", backgroundColor: "lightgrey" }} title={this.state.exclude1099Note} className="text-center"><img alt="link" src="/vendors/grrenLink.png" onClick={(e) => this.onLinkClick(data)}></img></td>
                                      </tr>
                                      :
                                      <tr onClick={(e) => this.onRowEdit(data.id, data)}>
                                        <td> {data.date}</td>
                                        <td>{data.transactionType}</td>
                                        <td >{data.num}</td>
                                        <td>{data.memoOrDescription}</td>
                                        <td> {data.accountValue}</td>
                                        <td className="text-center pr-2">${numberWithCommas(data.amount)}</td>
                                        <td></td>
                                        <td style={{ width: "12%" }} className="text-center"><img alt="link" src="/vendors/grrenLink.png" onClick={(e) => this.onLinkClick(data)}></img></td>
                                      </tr>
                                  }
                                  {this.state.editIndex === data.id && //item.vendor1099 &&
                                    <React.Fragment>
                                      <tr className="editRowColor review-1099-edit-row">
                                        <td colSpan={4}></td>
                                        <td colSpan={4}>
                                          <div className="review-1099-edit-controls">
                                            <div className="chiller_cb ">
                                              <input id="isExcludeFrom1099Total" name="isExcludeFrom1099Total" type="checkbox" checked={this.state.isExcludeFrom1099ReviewTotal} onChange={(e) => this.onChange1099ExcludeCheckbox(e)} />
                                              <label htmlFor="isExcludeFrom1099Total">
                                                <p className="checkbox-title" style={{ fontSize: "14px" }}>Exclude From 1099 Total</p>
                                              </label>
                                              <span></span>
                                            </div>
                                            <Button variant="contained" className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.onRowSave(data.id, data, item)}>SAVE</Button>
                                            <Button variant="contained" className="jr-btn jr-btn-sm bg-danger text-white" onClick={() => this.onRowCancel(data.id, data)}>CANCEL</Button>
                                          </div>
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  }
                                </React.Fragment>
                              ))}
                              {item.reportData.filter(a => a.transactionType !== "Bill" && a.isExcludeFrom1099Total == true).length > 0 &&
                                <React.Fragment>
                                  <tr>
                                    <td colSpan="4"></td>
                                    <td><h2 className="total-payments-text">Adjusted Total 1099 Payments</h2></td>
                                    <td className="text-center pr-2 compliance-review-1099-total-amount"><h1 className="total-text"> ${Getsum(item.reportData.filter(a => a.transactionType !== "Bill" && a.isExcludeFrom1099Total != true), "amount")} </h1></td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                </React.Fragment>
                              }
                              <tr>
                                <td colSpan="4"></td>
                                <td><h2 className="total-payments-text">Total Payments</h2></td>
                                <td className="text-center pr-2 compliance-review-1099-total-amount"><h1 className="total-text"> ${Getsum(item.reportData.filter(a => a.transactionType !== "Bill"), "amount")} </h1></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </React.Fragment>
                            :
                            <tr>
                              <td className="text-center" colSpan="8">
                                No Data Found!!!
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    }
                  </div>
                </div>
              ))
                :
                this.state.isDataLoadedSuccessfully && !this.state.loading ?
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "400px", fontSize: "24px", fontWeight: "bold", color: "#999" }}>
                    No Record Found
                  </div>
                  : null
              }

              {!this.state.loading && !this.state.LedgerDetailLoading &&
                <div className="sticky-button">
                  <FontTooltip id="tooltip-icon" title="Collapse All" placement="top">
                    <Button variant="contained" className={`jr-btn text-white sticky-btn collapse-btn ${this.state.collapsall ? "bg-teal" : "bg-blue-grey"}`}
                      onClick={() => this.onCollapseAllChange(false)}>
                      <img src="/vendors/Collapse.png" alt=""></img>
                    </Button>
                  </FontTooltip>
                  <FontTooltip id="tooltip-icon" title="Expand All" placement="bottom">
                    <Button variant="contained" className={`jr-btn text-white sticky-btn expand-btn ${this.state.expandall ? "bg-teal" : "bg-blue-grey"}`}
                      onClick={() => this.onExpandAllChange(true)}>
                      <img src="/vendors/Expand.png" alt=""></img>
                    </Button>
                  </FontTooltip>
                </div>}
            </React.Fragment>
          }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ComplianceReviewData: state.ledgers.ComplianceReviewData,
    CommonUpdate: state.ledgers.CommonUpdate,
    vendorTypeData: state.vendors.vendorTypes,
    doNotIssueDropdownOptions: state.vendors.doNotIssueDeopdownValues,
    wagesUpdate: state.vendors.wagesUpdate,
    HistoryData: state.ledgers.HistoryData,
    ComplianceReviewNotesUpdate: state.ledgers.ComplianceReviewNotesUpdate,
    GetComplianceReviewNotesData: state.ledgers.GetComplianceReviewNotesData,
    LEDGER_UPDATE: state.ledgers.LEDGER_UPDATE,
    UpdateDescription: state.ReportData.UpdateDescription,
  }
}
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    Get1099ComplianceReview,
    vendorTypes,
    doNotIssueDeopdownValues,
    UpdateVendor1099,
    SetVendorType,
    MarkVendorReview,
    GetReviewVendorHistory,
    InsertUpdateComplianceReviewNotes,
    GetComplianceReviewNotes,
    Update1099ReviewExcludeTotalStatus,
    UpdateVendorDoNotIssue1099,
    VendorStopMonitoring
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewReportPage);
